import React from 'react';

const SN = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_41"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_41)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#FDF14B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H7V15H0V0Z"
        fill="#009048"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 0H21V15H14V0Z"
        fill="#E71E27"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 8.75L9.03001 9.523L9.31001 7.886L8.12201 6.726L9.76501 6.489L10.5 5L11.235 6.49L12.878 6.727L11.688 7.887L11.968 9.523"
        fill="#009048"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default SN;
